import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Edit icon
 *
 * @category Files/Forms/Editing
 */
const Edit = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M28.732 7.485c-.683-1.115-2.721-2.829-3.644-3.823-.563-.48-1.246-.827-1.714-.288-1.942 1.954-16.18 16.18-17.607 17.619-.371.42-.335.515-.635 1.27-.432 1.199-1.438 3.908-1.882 5.118-.347.827-.108 1.726.971 1.415 1.63-.624 5.202-1.738 6.652-2.601.707-.695 9.073-9.073 14.131-14.131l3.104-3.105c.528-.515.84-.755.66-1.366l-.048-.108zM4.605 27.154c0-.624.695-2.026.946-2.793.264-.587.396-1.343.815-1.666.768-.108 1.39 1.007 2.218 1.666 1.63 1.438-.396 1.774-1.462 2.181-.66.168-2.05.923-2.481.695zM10.07 24.9c-.587-.42-2.11-2.001-2.685-2.6-.251-.276-.491-.648-.3-.948C9.004 19.4 19.06 9.38 22.98 5.46c.431-.419 1.102-1.306 1.797-.527.696.743 2.218 1.93 2.565 2.805-.827 1.594-3.703 3.775-6.64 6.975-3.2 3.045-7.587 7.983-10.547 10.212l-.096-.024z"
        />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="bevel"
          d="M10.12 29.101h19.177"
        />
      </svg>
    );
  }
);

Edit.displayName = 'Edit';

export { Edit };
